import { PROGRESS, REDIRECT_TIME, SUCCESS_SCREENS } from 'config/config';
import randomElement from 'helpers/randomElement';
import withProgressBar from 'hoc/withProgressBar';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  SuccessScreenButton,
  SuccessScreenContainer,
  SuccessScreenDescription,
  SuccessScreenIcon,
  SuccessScreenMessage,
  SuccessScreenTitle,
  SuccessScreenWrapper,
} from './SuccessScreen.styles';

const item = randomElement(SUCCESS_SCREENS);

class SuccessScreen extends PureComponent<IRedirect & Partial<IContext> & Partial<ITextContext>> {
  componentDidMount() {
    const { setPaymentStatusText } = this.props;
    if (setPaymentStatusText) {
      setPaymentStatusText('finalScreen.message5');
    }
    setTimeout(() => {
      this.redirectToUrl();
    }, REDIRECT_TIME);
  }

  handleClick = () => {
    this.redirectToUrl();
  };

  redirectToUrl = () => {
    const { redirect } = this.props;
    window.location.assign(redirect);
  };

  render() {
    const { title, icon, message, description, buttonText } = item;

    return (
      <SuccessScreenContainer className="success-screen__container">
        <SuccessScreenWrapper>
          <SuccessScreenTitle className="success-screen__title">
            <FormattedMessage id={title} />
          </SuccessScreenTitle>
          <SuccessScreenIcon className="success-screen__icon">
            <img src={icon} alt="icon" />
          </SuccessScreenIcon>
          <SuccessScreenMessage className="success-screen__message">
            <FormattedMessage id={message} />
          </SuccessScreenMessage>
          <SuccessScreenDescription className="success-screen__description">
            {description && <FormattedMessage id={description} />}
          </SuccessScreenDescription>
          <SuccessScreenButton onClick={this.handleClick} className="success-screen__button">
            <button type="button" id={buttonText}>
              <FormattedMessage id={buttonText} />
            </button>
            <div className="timer" />
          </SuccessScreenButton>
        </SuccessScreenWrapper>
      </SuccessScreenContainer>
    );
  }
}

export default withProgressBar(PROGRESS.PAYMENT_SUCCESS)(SuccessScreen);
